import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { hasPermissionForPath } from '../helpers/routePermissions';

const CustomRoute = ({ children, path }) => {
  const { authorizedPages, isAuthenticated } = useAuth();
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (path === '/rolePermission') {
    return <>{children}</>;
  }

  if (!Array.isArray(authorizedPages) || authorizedPages.length === 0) {
    return <>{children}</>;
  }

  const canAccessPage = hasPermissionForPath(authorizedPages, location.pathname);

  return canAccessPage ? <>{children}</> : <Navigate to="/" replace />;
};

export default CustomRoute;
